import { css, extractShadow, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';
import { PageContext } from 'hooks/shared/usePageContext.types';

type StyleProps = {
  isSidebarExpanded: boolean;
  pageContext: PageContext;
};

const styles = {
  root: ({ props: { isSidebarExpanded, pageContext } }) => css`
    display: flex;
    width: ${pageContext === PageContext.CentralInbox ? '100%' : '351px'};
    border-radius: 16px;
    flex-direction: column;
    background-color: white;
    position: relative;
    overflow: hidden;
    box-shadow: ${extractShadow((s) => s.robin2)};
    padding: 6px;
    height: 100%;
    ${isSidebarExpanded && 'max-height: 100%'};
  `,
  divider: css`
    display: block;
    margin: 12px 0px 4px;
    height: 1px;
    width: 90%;
    align-self: center;
    background-color: #dde3e7;
  `,
  headerPadding: css`
    padding: 6px 6px 0px;
  `,
  contentPadding: css`
    padding: 0px 6px;
  `,
  flexAlignment: css`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
  `,
} satisfies Styles<StyleProps>;

export const useStyles = withStyles(styles);
